<div class="rcc-pdf-custom-results">

  <div class="rcc-pdf-custom-results__header">
    <h1 class="rcc-pdf-custom-results__title">{{ pdfReportContent?.pagetitle }}</h1>
    <p class="rcc-pdf-custom-results__subtitle" *ngIf="printClientName">
      {{ pdfReportContent?.preparedfor }} {{ pdfReportContent?.for }} {{ printClientName }} {{ pdfReportContent?.on }}
      {{ printDate }}
    </p>
    <p class="rcc-pdf-custom-results__subtitle" *ngIf="!printClientName">
      {{ pdfReportContent?.preparedfor }} {{ pdfReportContent?.on }} {{ printDate }}
    </p>
  </div>
  <div class="rcc-pdf-custom-results__body">
    <h2 class="text-500 weight-bold pad-bottom-6">{{ pdfReportContent?.projectedConversionResults }}</h2>
    <thesis [type]="currentThesisType" [rothConversionTaxAmount]="rothConversionTaxAmount"
      [yearsUntilDist]="yearsUntilDist" [assetDifference]="assetDifference" [betrValue]="betrValue"
      [paymentMethod]="paymentMethod" />
    @if (chartImageDataUrl) {
    <img [src]="chartImageDataUrl" alt="Roth Conversion Chart"
      class="rcc-v4__print-chart-image pad-top-6 pad-bottom-6" />
    }
    <div class="text-under-chart">
      @if (hasProfitabilityPoint){
      <div class="axs-flex--col">
        <div class="definition">
          <img class="definition__icon" src="assets/svgs/Vector.svg" alt="" aria-hidden="true" />
          <b class="text-300 weight-bold">{{desirableProfitabilityPointContent?.profitabilitypoint}}</b>
        </div>
        <p class="text-250">{{desirableProfitabilityPointContent?.desirableprofitabilitydesc}}</p>
      </div>
      }
      @if(betrValue !== '0%'){
      <div class="axs-flex--col">
        <div class="definition">
          <img class="definition__icon" src="assets/images/BETR-Icon-Chart.svg" alt="" aria-hidden="true" />
          <b class="text-300 weight-bold">{{calculatorResultsContent.breakEvenTaxRate}}</b>
        </div>
        <p class="text-250">{{calculatorResultsContent.betrDesc}}</p>
      </div>
      }
    </div>
  </div>
</div>